<template>
  <section
    v-if="quota"
    class="quota-container"
    :aria-label="$t('organisationDetail.diskSpaceUsage')"
  >
    <div class="quota-container__header">
      <span class="quota-container__label">
        {{ $t('organisationDetail.diskSpaceUsage') }}
      </span>
      <span class="quota-container__usage">
        <span class="quota-container__figures">
          {{ quota.used_storage }}
          <span class="quota-container__sep">/</span>
          {{ quota.maximum_storage }}
        </span>
        <span class="quota-container__pct">
          {{ quota.storage_percent.toFixed(2) }}%
        </span>
      </span>
    </div>
    <b-progress
      class="quota-container__progress"
      :max="100"
      :value="quota.storage_percent"
      :variant="Math.round(quota.storage_percent) > 80
        ? 'danger'
        : Math.round(quota.storage_percent) > 60
          ? 'warning'
          : Math.round(quota.storage_percent) > 40
            ? 'info'
            : 'success'"
    >
      <b-progress-bar
        :value="Math.round(quota.storage_percent)"
        label=""
      />
    </b-progress>
  </section>
</template>

<script>
export default {
  name: 'OrganisationQuota',
  props: {
    quota: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="less" scoped>
.quota-container {
  box-sizing: border-box;
  margin: 1.25rem auto 0 1rem;
  padding: 1rem 1.25rem 1.125rem;
  text-align: left;
  background-color: mix(@blue, #fcfdfe, 5%);
  border: 1px solid mix(@blue, #e2eaef, 22%);
  border-radius: 10px;
  .quota-container__header {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    justify-content: space-between;
    gap: 0.5rem 1rem;
    margin-bottom: 0.75rem;
  }
  .quota-container__label {
    font-size: 0.6875rem;
    font-weight: 600;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: mix(#2f3234, @blue, 40%);
  }
  .quota-container__usage {
    display: inline-flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 0.35rem 0.5rem;
    font-size: 0.875rem;
    font-weight: 600;
    color: #2f3234;
    line-height: 1.2;
  }
  .quota-container__figures {
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.02em;
  }
  .quota-container__sep {
    font-weight: 500;
    color: mix(#2f3234, #fff, 55%);
    margin: 0 0.1em;
  }
  .quota-container__pct {
    font-size: 0.8125rem;
    font-weight: 600;
    color: @blue;
    font-variant-numeric: tabular-nums;
  }
  .quota-container__progress.progress {
    height: 0.625rem;
    border-radius: 999px;
    background-color: mix(@blue, #eef3f7, 10%);
    overflow: hidden;
  }
  .quota-container__progress .progress-bar {
    background-color: @blue;
    border-radius: 999px;
    transition: width 0.35s ease-out;
  }
}

@media (prefers-reduced-motion: reduce) {
  .quota-container .quota-container__progress .progress-bar {
    transition: none;
  }
}
</style>